import type { IMembersPolicy } from '@/api/organization/members/get-members-policy-query'

/** Customer-facing fallback used if the policy response omits its sole-admin reason. */
export const SOLE_ADMIN_LEAVE_MESSAGE =
    'You are the only admin of this organization. Give someone else admin access before leaving.'

/** Returns the sole-admin block reason while treating absent or permitted policy as leaveable. */
export function getWorkspaceLeaveBlockedReason(policy: IMembersPolicy | undefined) {
    return policy?.canCurrentUserLeave === false ? (policy.reason ?? SOLE_ADMIN_LEAVE_MESSAGE) : null
}
